import { render, staticRenderFns } from "./TerminalCompany.vue?vue&type=template&id=5aec1c0b"
import script from "./terminalCompany.ts?vue&type=script&lang=js&external"
export * from "./terminalCompany.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports